angular.module('natgeo').controller('Level3LearnScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ScreenView',
function Level3LearnScreen($scope, element, ScreenFactory, manager, container, ScreenView)
{
	var screen = ScreenFactory( 'level3_learn', element );

	// Store the current state so it can be restored later.
	screen.store();

	// How many times the screen has reloaded
	screen.loads = 0;

	// Before the screen is loaded...
	screen.on('introBefore', function()
	{
		if ( screen.loads > 0 )
		{
			// Restore screen to initial values
			screen.restore( ScreenView, container, $scope );
		}

		// Loaded!
		screen.loads++;
	});
	
	screen.once('introBefore', function()
	{
		anim8.save('fadeInDownRightGentle', {
			keyframe: {
				from: {
					translate: 10,
					opacity: 0
				},
				to: {
					translate: 0,
					opacity: 1
				}
			},
			units: {
				translate: '%'
			}
		});

		anim8.save('fadeInUpRightGentle', {
			keyframe: {
				from: {
					translate: {x:10, y:-10},
					opacity: 0
				},
				to: {
					translate: 0,
					opacity: 1
				}
			},
			units: {
				translate: '%'
			}
		});

		anim8.save('zoomInBottomRight', {
			keyframe: {
				from: {
					scale: 0,
					opacity: 0
				},
				to: {
					scale: 1,
					opacity: 1
				}
			},
			initial: {
				origin: 'right bottom'
			}
		})

	});

	// Show the next bee!
	$scope.nextBee = function()
	{
		screen.outroduce( 'realBee', 'fadeOut ~1s 2s' );
		screen.outroduce( 'nextBee', 'nextOut' );
		screen.outroduce( 'realBeeDescription', 'flipOutX' );

		screen.introduce( 'robotBee', 'fadeIn ~1s 2s' );
		screen.introduce( 'robotBeeDescription', 'fadeInDown' );
		screen.introduce( 'robotBeeDescriptionText', 'fadeIn ~1s' );
		screen.introduce( 'nextPurposes', 'nextIn ~2s' );
	};

	// Show the purpose animations
	$scope.nextPurposes = function()
	{
		screen.outroduce( 'robotBee', 'fadeOut' );
		screen.outroduce( 'nextPurposes', 'nextOut' );

		screen.view.find('.purposes').each(function()
		{
			var purpose = $(this);

			purpose
				.removeClass('hidden')
				.dataPlay('purpose')
				.applyInitialState()
			;

			if (!purpose.hasClass('keep'))
			{
				purpose
					.animators()
					.queue('fadeOut', {delay:2000})
					.once('finished', function()
					{
						purpose.addClass('hidden');
					})
				;
			}
		});
	};

	// The next screen is the plan screen
	$scope.next = function()
	{
		manager.transition('level3_plan');
	};
	
	// The previous screen is the define screen
	$scope.prev = function()
	{
		manager.transition('level3_define');
	};
	
}]);